export enum FeatureIndicatorType {
  Check = 'check',
  StrongText = 'strongText',
  WeakText = 'weakText',
}
